



























































































































































































































































































































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import {
  IPrivateAccount,
  getAccountStatus,
  getAccountList,
  getAccountArea,
  addEditAccount,
  deleteAccount,
  setAccountUsed,
  resetAccount,
  checkAccount,
  getReSignStatus,
  changeStatus
} from '@/api/developer/developer-private/private'
import { exportJson2Excel } from '@/utils/excel'
import {
  formatJson,
  resetObjValue2NoneString,
  checkNoneString,
  deepCopy,
  confirmMiddleWare
} from '@/utils/tool'
import { Form } from 'element-ui'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'

type actStatus = 'open' | 'close'
interface option {
  value: string
  text: string
}
@Component({
  name: 'DeveloperPirvateAccount'
})
export default class extends mixins(DateOption) {
  // api data
  private params = {
    id: '',
    account: '',
    status: '',
    area: '',
    info: '',
    createDateStart: '',
    createDateEnd: '',
    orderBy: '', // asc desc ''
    page: 1,
    pageCount: 20,
    accountUsage: '0'
  }
  private addParams = {
    id: 0,
    area: 'random',
    account: '',
    password: '',
    accountUsage: 0
  }
  options: option[] = [
    {
      text: '所有证书',
      value: '0'
    },
    {
      text: '新用户',
      value: '1'
    },
    {
      text: '回签',
      value: '2'
    }
  ]
  // component data
  tableLoading = false
  private tableData: any[] = []
  private statusList: any[] = []
  private areaList: any[] = []
  private selectedData: any[] = []
  private dateArray: string[] = ['', '']
  private totalCount = 0
  private addFormVisible: boolean = false
  private onOff: string = 'on'
  private rules: any = {
    account: [{ required: true, message: '请填写账号', trigger: 'blur' }],
    password: [{ required: true, message: '请填写密码', trigger: 'blur' }]
  }
  private tableHeight: number = 500
  private config: any = {
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    type: 'warning'
  }
  private confirmMiddleWare: Function = confirmMiddleWare
  private statusMap: Map<String, String> = new Map([['OK', 'six'], ['账号已被封禁', 'seven'], ['处理中', 'five']])
  // lifecycle
  async created() {
    this.getTableData()
    this.getAccountStatus()
    this.getAreaList()
    this.getStatus()
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
  }
  beforeDestroy() {
    window.removeEventListener('resize', this.setTableHeight)
  }
  // methods
  async getTableData() {
    try {
      this.tableLoading = true
      let res: any = await getAccountList(this.params)
      this.tableData = res.data.dataList || []
      this.totalCount = res.data.pageInfo.totalCount
    } catch (error) {
      this.$message.error(error as string)
    } finally {
      this.tableLoading = false
    }
  }
  setTableHeight() {
    const filter: any = this.$refs.filter
    const filterDom: any = filter.$el
    this.tableHeight = document.body.clientHeight - 250 - filterDom.clientHeight
  }
  async getAccountStatus() {
    let res: any = await getAccountStatus()
    this.statusList = res.data.dataList
  }
  handleCopy(event: any) {
    let text: string = event.target.dataset['clipboardText'] // 使用大驼峰命名法获取
    const input = document.createElement('input')
    document.body.appendChild(input)
    input.setAttribute('value', text)
    input.select()
    try {
      var flag = document.execCommand('copy') // 执行复制
      this.$message.success('复制成功')
    } catch (err) {
      flag = false
      this.$message.warning('复制失败')
    }
    document.body.removeChild(input) // 删除元素
    return flag
  }
  handleSelectAll() {
    // 如果没有选择全部, 则寻找未选择的行, 并将这些行选中
    if (this.selectedData.length < this.tableData.length) {
      let tempSelectList = this.selectedData.map(item => item.id)
      let unSelected: any[] = this.tableData.filter((item: any) => !tempSelectList.includes(item.id))
      unSelected.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handleSelectReverse() {
    this.selectedData = []
    let tempList: number[] = []
    let tempSelectList: number[] = []
    let indexList: number[] = []
    tempList = this.tableData.map(item => item.id)
    tempSelectList = this.selectedData.map(item => item.id)
    indexList = tempList.filter(item => !tempSelectList.includes(item))
    this.tableData.forEach(item => {
      if (indexList.includes(item.id)) this.selectedData.push(item)
    })
    if (this.selectedData.length) {
      this.selectedData.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  async handleExcel() {
    // let excelParams = deepCopy(this.params)
    // let res: any = await getAccountList(
    //   Object.assign(excelParams, {
    //     page: 1,
    //     pageCount: 3000
    //   })
    // )
    // if (res.status.code === 0) {
    //   setTimeout(() => {
    //     this['$message'].success('导出成功!')
    //   }, 200)
    // } else {
    //   this['$message'].error('导出失败!')
    //   return
    // }
    const filterVal: string[] = [
      'id',
      'accountId',
      'certName',
      'applePwd',
      'iphoneCount',
      'itouchCount',
      'status',
      'info',
      'createDate',
      'creatorName'
    ]
    const theader: string[] = [
      'ID',
      '开发者账号',
      '证书',
      '专用密码',
      'iPhone可安装数量',
      'iPad可安装数量',
      '状态',
      '信息',
      '创建时间',
      '创建人'
    ]
    if (this.selectedData.length <= 0) {
      return this.$message.warning('请选择数据')
    }
    const list = this.tableData
    const data = formatJson(filterVal, list)
    exportJson2Excel(theader, data)
    this['$message'].success('导出成功!')
    ;(this.$refs['multiTable'] as any).clearSelection()
  }
  async getAreaList() {
    let res: any = await getAccountArea()
    console.log(res)
    this.areaList = res.data.dataList
  }
  async addEditAccount() {
    this.addParams.accountUsage = Number(this.addParams.accountUsage)
    let res: any = await addEditAccount(this.addParams)
    if (res.status.code === 0) {
      this['$message'].success('提交成功!')
      this.cancelAddForm()
      this.getTableData()
    } else {
      this['$message'].error('提交失败!')
    }
  }
  handleSwitch(status: string) {
    let st = status
    this.onOff = this.onOff === 'on' ? 'off' : 'on'
    let statusMap = new Map([['on', '开启'], ['off', '关闭']])
    this.$confirm(`确认${statusMap.get(st)}回签?`, '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        changeStatus().then((res: any) => {
          if (res.status.code === 0) {
            this['$message'].success('操作成功')
            this.onOff = this.onOff === 'on' ? 'off' : 'on'
          } else {
            this['$message'].error('操作失败')
          }
        })
          .catch((err) => { console.log(err) })
      })
      .catch(() => {})
  }
  deleteAccount(ids: string) {
    this.$confirm('确认删除该数据?', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async() => {
        let res: any = await deleteAccount({
          id: ids
        })
        if (res.status.code === 0) {
          this['$message'].success('删除成功')
          this.getTableData()
        } else {
          this['$message'].error('删除失败')
        }
      })
      .catch(() => {})
  }
  // 批量开启 && 关闭
  async setAccount(type: actStatus, ids: string) {
    this.tableLoading = true
    let isUsed = type === 'open'
    let res: any = await setAccountUsed({
      id: ids,
      use: isUsed ? 1 : -1
    })
    if (res.status.code === 0) {
      let t = ids.split(',')
      this.tableData.forEach(item => {
        if (t.includes(item.id.toString())) {
          item.isUse = isUsed
        }
      })
      isUsed
        ? this['$message'].success('账号启用成功!')
        : this['$message'].info('账号关闭成功!')
      this.tableLoading = false
    }
    this.tableLoading = false
  }
  handleDateChange(date: string[]) {
    this.params.createDateStart = date && date[0]
    this.params.createDateEnd = date && date[1]
  }
  handleSearch() {
    if (this.tableLoading) { return false }
    let params:any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  handleReset() {
    resetObjValue2NoneString(this.params, ['page', 'pageCount'])
    this.params.page = 1
    this.dateArray = ['', '']
    this.params.accountUsage = '0'
    this.getTableData()
  }
  async getStatus() {
    let res: any = await getReSignStatus()
    this.onOff = res.data.status
  }
  handleAdd() {
    this.addFormVisible = true
  }
  handleSelectionChange(list: any[]) {
    this.selectedData = list
  }
  handleSortChange(item: any) {
    const { order } = item
    this.params.orderBy = order ? (order === 'ascending' ? 'asc' : 'desc') : ''
    this.params.page = 1
    this.getTableData()
  }
  handleOpenAll(type: actStatus) {
    let canClose = this.selectedData.some(item => item.isUse)
    if (canClose) {
      this['$message'].warning('请选择正确状态的账号进行启用!')
      return
    }
    this.setAccount(type, this.selectIds)
  }
  handleCloseAll(type: actStatus) {
    let canClose = this.selectedData.some(item => !item.isUse)
    if (canClose) {
      this['$message'].warning('请选择正确状态的账号进行关闭!')
      return
    }
    this.setAccount(type, this.selectIds)
  }
  handleRemoveAll() {
    let canDelete = this.selectedData.some(item => item.isUse)
    if (canDelete) {
      this['$message'].warning('请选择正确状态的账号进行删除!')
      return
    }
    this.deleteAccount(this.selectIds)
  }
  async setUsed(item: IPrivateAccount) {
    this.tableLoading = true
    const { id } = item
    let res: any = await setAccountUsed({
      id: id.toString(),
      use: 1
    })
    if (res.status.code === 0) {
      this.$nextTick(() => {
        item.isUse = true
        // item.status = '待预处理'
        // item.statusId = 2
      })
      this['$message'].success('账号启用成功!')
    } else {
      this['$message'].error('账号启用失败!')
    }
    this.tableLoading = false
  }
  async setunUsed(item: IPrivateAccount) {
    this.tableLoading = true
    const { id } = item
    let res: any = await setAccountUsed({
      id: id.toString(),
      use: -1
    })
    if (res.status.code === 0) {
      this.$nextTick(() => {
        item.isUse = false
      })
      this['$message'].success('账号关闭成功!')
    } else {
      this['$message'].error('账号关闭失败!')
    }
    this.tableLoading = false
  }
  setUpdate(item: any) {
    console.log(item)
    this.addParams.id = item.id
    this.addParams.area = item.serverArea
    this.addParams.account = item.accountId
    this.addParams.password = item.applePwd
    this.addParams.accountUsage = item.accountUsage.toString()
    this.addFormVisible = true
  }
  setRemove(item: any) {
    let ids = item.id.toString()
    this.deleteAccount(ids)
  }
  // close dialog, clear data
  handleFormClose() {
    this.cancelAddForm()
  }
  cancelAddForm() {
    this.addParams = {
      id: 0,
      area: 'random',
      account: '',
      password: '',
      accountUsage: 0
    }
    this.addFormVisible = false
  }
  confirmAddForm() {
    let valid = this.addParams.account && this.addParams.password && this.addParams.accountUsage
    if (valid) {
      this.addEditAccount()
    } else {
      return this['$message'].warning('请填写完成后再提交!')
    }
  }
  _resetAccount(obj: any) {
    this.$confirm('确认重置账号?', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async() => {
        this.tableLoading = true
        let id = obj.id
        let res: any = await resetAccount({
          id: id
        })
        if (res.status.code === 0) {
          this['$message'].success('账号重置成功')
          this.getTableData()
        } else {
          this['$message'].error('账号重置失败')
        }
        this.tableLoading = false
      })
      .catch(() => {})
  }
  _checkAccount(obj: any) {
    this.$confirm(`确认 检测账号${obj.accountId}?`, '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async() => {
        this.tableLoading = true
        let id = obj.id
        let res: any = await checkAccount({
          id: id
        })
        if (res.status.code === 0) {
          this['$message'].success('账号检测成功')
          this.getTableData()
        }
        this.tableLoading = false
      })
      .catch(() => {})
  }
  // computed
  get showMultiSelect() {
    return this.selectedData.length > 1
  }
  get selectCount() {
    return this.selectedData.length
  }
  get selectIds() {
    let t: number[] = []
    this.selectedData.forEach(item => {
      t.push(item.id)
    })
    let ids = t.join(',')
    return ids
  }
}
